import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SmartDentAction } from '../actions/SmartDentAction';
import {
    DEFAULT_QR_BOX,
    DEFAULT_TYPE_BOX,
    DEFAULT_BG_BOX,
    DEFAULT_MARGINS,
    clampQrBox,
    clampTypeBox,
    clampBgBox,
    clampMargins,
} from '../lib/voucherTemplate';

// IMP-107 (AC-2): companyId 기반 템플릿 로드 + 로컬 폼 상태 소유/초기화 훅.
// VoucherTemplateEditor 에서 이전. Redux 의 voucherTemplate 을 받아 편집용 로컬 상태를 동기화하고,
// 편집 setter 를 View 에 노출한다. (View 의 drag/fit/orientation 핸들러가 이 setter 들을 사용)
// product(선택): 호출자가 key 기준으로 고정한 객체여야 한다(effect deps — 새 객체를 매 렌더 주면 재조회 순환). 생략 = SMARTDent.
export const useVoucherTemplateLoader = (companyId, voucherTemplate, product) => {
    const dispatch = useDispatch();

    const [qrBox, setQrBox] = useState(DEFAULT_QR_BOX);
    const [typeBox, setTypeBox] = useState(DEFAULT_TYPE_BOX);
    const [bgUrl, setBgUrl] = useState(null);
    const [orientation, setOrientation] = useState('portrait');
    const [bgBox, setBgBox] = useState(DEFAULT_BG_BOX);
    const [margins, setMargins] = useState(DEFAULT_MARGINS);

    // 마운트/회사 변경 시 템플릿 로드.
    useEffect(() => {
        if (companyId) dispatch(SmartDentAction.GetVoucherTemplate(companyId, { product }));
    }, [dispatch, companyId, product]);

    // Redux 상태에서 템플릿을 받아 로컬 편집 상태 초기화.
    // BE resetTemplate 가 ancestor walk-up 으로 HQ 값을 응답에 담아주므로 그대로 사용.
    // BE 응답이 부재한 필드만 FE 기본값 fallback.
    useEffect(() => {
        if (voucherTemplate) {
            setQrBox(clampQrBox(voucherTemplate.qrBox || DEFAULT_QR_BOX));
            setTypeBox(clampTypeBox(voucherTemplate.typeBox || DEFAULT_TYPE_BOX));
            setBgUrl(voucherTemplate.backgroundImageUrl || null);
            setOrientation(voucherTemplate.orientation === 'landscape' ? 'landscape' : 'portrait');
            setBgBox(clampBgBox(voucherTemplate.bgBox || DEFAULT_BG_BOX));
            setMargins(clampMargins(voucherTemplate.margins || DEFAULT_MARGINS));
        }
    }, [voucherTemplate]);

    return {
        qrBox, setQrBox,
        typeBox, setTypeBox,
        bgUrl, setBgUrl,
        orientation, setOrientation,
        bgBox, setBgBox,
        margins, setMargins,
    };
};

export default useVoucherTemplateLoader;
